// extracted by mini-css-extract-plugin
module.exports = {"square_input":"page_square_input__xR45T"};